<template>
  <dl class="dl-row">
    <dt class="dt-title">{{ name }}</dt>
    <dd
        v-for="v in values"
        :key="v['name']"
        :class="getItemClass(v)"
        @click="handleSelect(v)"
    >{{ v['text'] }}</dd>
  </dl>
</template>

<script setup>
const props = defineProps(['name', 'values', 'requires'])
const emits = defineEmits(['onChange'])
const handleSelect = (v) => {
  let key = v['name']
  if(!props.requires[key]){
    v['checked'] = !v['checked'];
    emits('onChange', v);
  }
}
const getItemClass = (v) => {
  let key = v['name']
  let require = props.requires[key];
  return {
    'dd-active':  !v['checked'] && !require,
    'dd-require':  require
  }
}
</script>

<style lang="less" scoped>
.dl-row{
  font-size: 12px;
  color: #999;
  display: flex;
  padding: 4px 0;

  & dd{
    margin: 0 10px;
    cursor: pointer;

    &:hover, &.dd-active{
      color: #0A9BFC;
    }

    &.dd-require{
      color: #0A9BFC;
    }

    &.dd-require::before{
      content: '*';
    }
  }

  .dt-title{
    width: 70px;
  }
}
</style>